import { CascaderSubmenu } from './types';

const SEARCH_LIST_PARTS = [
  'searchWrapper',
  'searchOptionsList',
  'searchOption',
] as const;

const INPUT_CONTROL_PARTS = [
  'control',
  'input',
  'dropdownIndicator',
  'indicatorSeparator',
  'indicatorsContainer',
  'clearIndicator',
  'singleSelectedValue',
  'selectedValueContainer',
  'placeholder',
  'indicatorSeparator',
] as const;

const MENU_PARTS = [
  'leafOption',
  'submenuOption',
  'menuWrapper',
  'submenuWrapper',
  'submenuHeader',
  'submenuGroupWrapper',
  'submenuGroupHeader',
  'submenuGroupItemList',
  'submenuGroupDivider',
] as const;

export const CASCADER_PARTS = [
  'container',
  'positioningContainer',
  'noOptionsMessage',
  ...MENU_PARTS,
  ...SEARCH_LIST_PARTS,
  ...INPUT_CONTROL_PARTS,
] as const;

// Component names that correspond to the CascaderComponents interface
export const CASCADER_SUBCOMPONENT_NAMES = {
  // Container / Common Subcomponents
  CONTAINER: 'Container',
  POSITIONING_CONTAINER: 'PositioningContainer',
  NO_OPTIONS_MESSAGE: 'NoOptionsMessage',
  // Input Control Subcomponents
  CONTROL: 'Control',
  INPUT: 'Input',
  PLACEHOLDER: 'Placeholder',
  CLEAR_INDICATOR: 'ClearIndicator',
  DROPDOWN_INDICATOR: 'DropdownIndicator',
  INDICATOR_SEPARATOR: 'IndicatorSeparator',
  INDICATORS_CONTAINER: 'IndicatorsContainer',
  SELECTED_VALUE_CONTAINER: 'SelectedValueContainer',
  SINGLE_SELECTED_VALUE: 'SingleSelectedValue',
  // Search Subcomponents
  SEARCH_WRAPPER: 'SearchWrapper',
  SEARCH_OPTIONS_LIST: 'SearchOptionsList',
  SEARCH_OPTION: 'SearchOption',
  // Menu Subcomponents
  LEAF_OPTION: 'LeafOption',
  SUBMENU_OPTION: 'SubmenuOption',
  MENU_WRAPPER: 'MenuWrapper',
  SUBMENU_WRAPPER: 'SubmenuWrapper',
  SUBMENU_HEADER: 'SubmenuHeader',
  SUBMENU_GROUP_WRAPPER: 'SubmenuGroupWrapper',
  SUBMENU_GROUP_HEADER: 'SubmenuGroupHeader',
  SUBMENU_GROUP_ITEM_LIST: 'SubmenuGroupItemList',
  SUBMENU_GROUP_DIVIDER: 'SubmenuGroupDivider',
} as const;

export const MENU_ITEM_STYLES = {
  minWidth: 15,
  maxWidth: 50,
  minHeight: 3.5,
  py: 0.5,
  pl: 2,
  pr: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  gap: 1,
  flexShrink: 0,
};

export const ICON_STYLES = {
  color: 'feature.secondary',
  h: 2.5,
  w: 2.5,
  flexShrink: 0,
};

export const EMPTY_SUBMENU: CascaderSubmenu = {
  label: 'All',
  value: 'root',
  children: [],
};
